import { useIntl } from "react-intl";
import { parse } from "date-fns";
import * as yup from "yup";
import { CalendarDateSelector } from "..";
import messages from "./messages.i18n";
import { TimeWindowSelector } from "../time-window-selector";
import { ScannerEmailSelector } from "../scanner-email-selector";
export const ScheduleFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object({
        scheduledFor: yup
            .date()
            .transform((_value, originalValue) => parse(originalValue, "MM/dd/yy", new Date()))
            .typeError(intl.formatMessage(messages.scheduleInputError))
            .required(intl.formatMessage(messages.scheduleInputRequired)),
        scannerEmail: yup.string().email(intl.formatMessage(messages.scheduleEmailError)).nullable(),
    });
};
export const ScheduleFormInitialValues = {
    scheduledFor: "",
    scannerArrivalWindow: {
        from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getUTCDate(), 10, 0),
        to: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getUTCDate(), 11, 0),
    },
};
export const ScheduleFormFields = (organizationId) => {
    const intl = useIntl();
    return {
        scheduledFor: [
            {
                id: "scheduledFor",
                label: intl.formatMessage(messages.scheduleScannerDateLabel),
                placeholder: intl.formatMessage(messages.scheduleScannerDatePlaceholder),
                required: true,
                columns: 12,
                isAbsolute: false,
                disabled: !organizationId,
                component: CalendarDateSelector,
            },
            {
                id: "scannerArrivalWindow",
                label: intl.formatMessage(messages.scheduleScannerTimeWindowLabel),
                placeholder: "",
                required: true,
                columns: 12,
                isAbsolute: false,
                disabled: !organizationId,
                component: TimeWindowSelector,
            },
            {
                id: "scannerEmail",
                label: intl.formatMessage(messages.scheduleScannerEmailLabel),
                placeholder: intl.formatMessage(messages.scheduleScannerEmailPlaceholder),
                required: false,
                columns: 12,
                isAbsolute: false,
                disabled: !organizationId,
                component: ScannerEmailSelector,
            },
        ],
    };
};
